export const QUERY_STALE_TIME = 5 // minutes
/**
 * Age-related constants
 */
export const AGE = {
  MIN: 17,
  MAX: 100,
} as const

/**
 * OTP-related constants
 */
export const OTP = {
  TIMEOUT_MS: 180000, // 3 minutes in milliseconds
} as const

/**
 * API tokens
 */
export const API_TOKENS = {
  REMINDER_TOKEN: 'dXNlckBNTVA6YWJjMTIz',
} as const

/**
 * Feature flags for different environments
 */
export const FEATURE_FLAGS = {
  // Set to false to hide these features
  SHOW_CANCEL_POLICY_BUTTON: true,
} as const

/**
 * System configuration keys
 */
export const SYSTEM_CONFIG_KEYS = {
  EWALLET_ENABLED: 'EWalletEnabled',
  EARN_POINTS_RATIO: 'EarnPointsRatio',
} as const

// Storage keys
export const STORAGE_KEYS = {
  CHECK_EXPIRING_POLICIES: 'check-expiring-policies',
} as const

/**
 * Insurance company codes as returned by the aggregator
 */
export const INSURANCE_COMPANY_CODES = {
  TAWUNIYA: 50,
} as const
